/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { BasicDirectorUserInfoDTO, BasicUserInfoDTO, BooleanResponseWrapper, UserBaseModel, UserModel, UserModelResponseWrapper } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Users<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags User
   * @name GetByUserId
   * @request GET:/Users/GetUserById:{userId}
   */
  getByUserId = (userId: number, params: RequestParams = {}) =>
    this.request<UserModel, any>({
      path: `/Users/GetUserById:${userId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetBasicInfoByUserId
   * @request GET:/Users/BasicInfo/GetBasicUserInfoById:{userId}
   */
  getBasicInfoByUserId = (userId: number, params: RequestParams = {}) =>
    this.request<UserBaseModel, any>({
      path: `/Users/BasicInfo/GetBasicUserInfoById:${userId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetBasicDirectorUserInfoByEmail
   * @request GET:/Users/BasicDirectorInfoByEmail:{email}
   */
  getBasicDirectorUserInfoByEmail = (email: string, params: RequestParams = {}) =>
    this.request<BasicDirectorUserInfoDTO, any>({
      path: `/Users/BasicDirectorInfoByEmail:${email}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetBasicUserInfoByEmail
   * @request GET:/Users/BasicUserInfoByEmail:{email}
   */
  getBasicUserInfoByEmail = (email: string, params: RequestParams = {}) =>
    this.request<BasicUserInfoDTO, any>({
      path: `/Users/BasicUserInfoByEmail:${email}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetByUsername
   * @request GET:/Users/GetByUserName:{username}
   */
  getByUsername = (username: string, params: RequestParams = {}) =>
    this.request<UserModel, any>({
      path: `/Users/GetByUserName:${username}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetAllUsers
   * @request GET:/Users/GetAllUsers
   */
  getAllUsers = (params: RequestParams = {}) =>
    this.request<UserBaseModel[], any>({
      path: `/Users/GetAllUsers`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetAllCoachUsers
   * @request GET:/Users/GetAllCoachUsers
   */
  getAllCoachUsers = (params: RequestParams = {}) =>
    this.request<UserBaseModel[], any>({
      path: `/Users/GetAllCoachUsers`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetAllDirectorUsers
   * @request GET:/Users/GetAllDirectorUsers
   */
  getAllDirectorUsers = (params: RequestParams = {}) =>
    this.request<UserBaseModel[], any>({
      path: `/Users/GetAllDirectorUsers`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetAllVendorUsers
   * @request GET:/Users/GetAllVendorUsers
   */
  getAllVendorUsers = (params: RequestParams = {}) =>
    this.request<UserBaseModel[], any>({
      path: `/Users/GetAllVendorUsers`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name SaveUser
   * @request POST:/Users/SaveUser
   */
  saveUser = (data: UserModel, params: RequestParams = {}) =>
    this.request<UserModelResponseWrapper, any>({
      path: `/Users/SaveUser`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name SaveUserWithPassword
   * @request POST:/Users/SaveUserWithPassword
   */
  saveUserWithPassword = (data: UserModel, params: RequestParams = {}) =>
    this.request<UserModelResponseWrapper, any>({
      path: `/Users/SaveUserWithPassword`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name AddUser
   * @request POST:/Users/AddUser
   */
  addUser = (data: UserBaseModel, params: RequestParams = {}) =>
    this.request<UserModelResponseWrapper, any>({
      path: `/Users/AddUser`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name PatchUser
   * @request PATCH:/Users
   */
  patchUser = (data: UserBaseModel, params: RequestParams = {}) =>
    this.request<UserModelResponseWrapper, any>({
      path: `/Users`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name DeleteUser
   * @request DELETE:/Users/DeleteUser
   */
  deleteUser = (
    query?: {
      /** @format int32 */
      userId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/Users/DeleteUser`,
      method: 'DELETE',
      query: query,
      format: 'json',
      ...params,
    });
}
